(function () {
  var HOME_HANDLES = {
    home: true,
    'for-brands': true,
    'district-mailing-direct': true,
    'dm-for-brands': true,
  };

  var DIRECT_HOME_PATH = '/pages/dm-for-brands';

  var TITLES = {
    solutions: 'Solutions',
    'marketplace-accelerator': 'Marketplace Accelerator',
    'marketplace-prep': 'Marketplace Prep',
    services: 'Services',
    fulfillment: 'Fulfillment',
    '3pl': '3PL Services',
    dtc: 'DTC',
    'what-we-do': 'What We Do',
    'how-it-works': 'How It Works',
    industries: 'Industries',
    'success-stories': 'Success Stories',
    'why-district-mailing': 'Why District Mailing',
    'about-district-mailing-direct': 'About',
    about: 'About',
    'dm-direct-faq': 'FAQ',
    faq: 'FAQ',
    'dm-direct-contact': 'Contact',
    contact: 'Contact',
    'for-brands': 'District Mailing Direct',
    'district-mailing-direct': 'District Mailing Direct',
    'dm-for-brands': 'District Mailing Direct',
  };

  var closeNavMenus = function () {};

  function initNav() {
    var root = document.querySelector('[data-dm-direct-nav]');
    if (!root) return;
    var burger = root.querySelector('[data-dm-direct-burger]');
    var mobile = root.querySelector('#dmDirectMobile');
    if (burger && mobile) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) mobile.setAttribute('hidden', '');
        else mobile.removeAttribute('hidden');
      });
    }

    var dropdowns = Array.prototype.slice.call(
      root.querySelectorAll('.dm-direct-nav__dropdown')
    );
    if (!dropdowns.length) {
      closeNavMenus = function () {
        if (burger && mobile) {
          burger.setAttribute('aria-expanded', 'false');
          mobile.setAttribute('hidden', '');
        }
      };
      return;
    }

    var desktop = window.matchMedia('(min-width: 980px)');
    var touchNavigation = window.matchMedia('(hover: none)');
    var openTimer = null;
    var closeTimer = null;
    var active = null;

    function clearTimers() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
    }

    function setOpen(next) {
      clearTimers();
      dropdowns.forEach(function (item) {
        var trigger = item.querySelector(':scope > a');
        var isOpen = item === next;
        item.classList.toggle('is-open', isOpen);
        if (trigger) trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
      active = next || null;
    }

    function scheduleOpen(item) {
      if (!desktop.matches) return;
      clearTimers();
      openTimer = window.setTimeout(function () {
        setOpen(item);
      }, active ? 35 : 80);
    }

    function scheduleClose(item) {
      clearTimers();
      closeTimer = window.setTimeout(function () {
        if (active === item && !item.contains(document.activeElement)) setOpen(null);
      }, 220);
    }

    dropdowns.forEach(function (item) {
      var trigger = item.querySelector(':scope > a');
      var panel = item.querySelector(':scope > .dm-direct-nav__panel');
      if (!trigger || !panel) return;

      item.addEventListener('mouseenter', function () {
        scheduleOpen(item);
      });
      item.addEventListener('mouseleave', function () {
        scheduleClose(item);
      });
      item.addEventListener('focusin', function () {
        setOpen(item);
      });
      item.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!item.contains(document.activeElement)) scheduleClose(item);
        }, 0);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(item);
          var firstLink = panel.querySelector('a');
          if (firstLink) firstLink.focus();
        } else if (event.key === 'Escape') {
          setOpen(null);
          trigger.focus();
        }
      });

      trigger.addEventListener('click', function (event) {
        if (desktop.matches && touchNavigation.matches && active !== item) {
          event.preventDefault();
          setOpen(item);
        }
      });

      panel.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(null);
          trigger.focus();
        }
      });
    });

    document.addEventListener('pointerdown', function (event) {
      if (!root.contains(event.target)) setOpen(null);
    });

    desktop.addEventListener('change', function () {
      setOpen(null);
    });

    closeNavMenus = function () {
      var focused = document.activeElement;
      if (focused && focused !== document.body && root.contains(focused) && focused.blur) {
        focused.blur();
      }
      setOpen(null);
      if (burger && mobile) {
        burger.setAttribute('aria-expanded', 'false');
        mobile.setAttribute('hidden', '');
      }
    };
  }

  var revealObserver = null;

  function initIndustries(scope) {
    var root = (scope || document).querySelector('[data-dm-industries]');
    if (!root || root.hasAttribute('data-dm-ind-bound')) return;
    root.setAttribute('data-dm-ind-bound', '');

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-dm-ind-id]'));
    var panel = root.querySelector('[data-dm-ind-panel]');
    var title = root.querySelector('[data-dm-ind-title]');
    var body = root.querySelector('[data-dm-ind-body]');
    if (!buttons.length || !panel || !title || !body) return;

    var gradients = {
      health: 'linear-gradient(135deg, #0c3b5c, #174EA6)',
      medical: 'linear-gradient(135deg, #0a2238, #1d4ed8)',
      beauty: 'linear-gradient(135deg, #1a2744, #3B82F6)',
      lifestyle: 'linear-gradient(135deg, #0f2a44, #2563eb)',
      automotive: 'linear-gradient(135deg, #07192B, #1e3a5f)',
      home: 'linear-gradient(135deg, #12324f, #174EA6)',
      consumer: 'linear-gradient(135deg, #10253d, #1d4ed8)',
    };

    function activate(btn) {
      buttons.forEach(function (item) {
        var on = item === btn;
        item.classList.toggle('is-active', on);
        item.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      title.textContent = btn.getAttribute('data-dm-ind-name') || '';
      body.textContent = btn.getAttribute('data-dm-ind-desc') || '';
      var id = btn.getAttribute('data-dm-ind-id') || 'health';
      panel.setAttribute('data-dm-ind-active', id);
      panel.style.backgroundImage = gradients[id] || gradients.health;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn);
      });
      btn.addEventListener('mouseenter', function () {
        if (window.matchMedia('(hover: hover)').matches) activate(btn);
      });
    });

    activate(buttons[0]);
  }

  function easeOutExpo(t) {
    return t >= 1 ? 1 : 1 - Math.pow(2, -10 * t);
  }

  function animateStatCount(el) {
    var target = parseFloat(el.getAttribute('data-dm-count-to') || '0');
    var numEl = el.querySelector('[data-dm-count-num]');
    if (!numEl || el.getAttribute('data-dm-count-done') === '1') return;

    el.setAttribute('data-dm-count-done', '1');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      numEl.textContent = String(Math.round(target));
      return;
    }

    var duration = 1400;
    var start = null;

    function frame(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var value = Math.round(easeOutExpo(t) * target);
      numEl.textContent = String(value);
      if (t < 1) {
        window.requestAnimationFrame(frame);
      } else {
        numEl.textContent = String(Math.round(target));
      }
    }

    numEl.textContent = '0';
    window.requestAnimationFrame(frame);
  }

  var countObserver = null;

  function initStatCounters(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('[data-dm-count]');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, animateStatCount);
      return;
    }

    if (!countObserver) {
      countObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animateStatCount(entry.target);
            countObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.45 }
      );
    }

    Array.prototype.forEach.call(nodes, function (n) {
      if (n.getAttribute('data-dm-count-bound') === '1') return;
      n.setAttribute('data-dm-count-bound', '1');
      if (n.getAttribute('data-dm-count-done') === '1') return;
      countObserver.observe(n);
    });
  }

  function initTestimonials(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-dm-testimonials]');
    if (!sections.length) return;

    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-dm-testimonials-bound') === '1') return;
      section.setAttribute('data-dm-testimonials-bound', '1');

      var slides = Array.prototype.slice.call(
        section.querySelectorAll('[data-dm-testimonial-slide]')
      );
      var dots = Array.prototype.slice.call(
        section.querySelectorAll('[data-dm-testimonial-dot]')
      );
      var prev = section.querySelector('[data-dm-testimonial-prev]');
      var next = section.querySelector('[data-dm-testimonial-next]');
      if (!slides.length) return;

      var index = 0;

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var on = i === index;
          slide.classList.toggle('is-active', on);
          if (on) slide.removeAttribute('hidden');
          else slide.setAttribute('hidden', '');
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = parseInt(dot.getAttribute('data-dm-testimonial-dot') || '0', 10);
          show(i);
        });
      });

      show(0);
    });
  }

  function initFaqAccordion(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-dm-faq]');
    if (!sections.length) return;

    Array.prototype.forEach.call(sections, function (section) {
      if (section.getAttribute('data-dm-faq-bound') === '1') return;
      section.setAttribute('data-dm-faq-bound', '1');

      var items = Array.prototype.slice.call(
        section.querySelectorAll('[data-dm-faq-item]')
      );

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-dm-faq-trigger]');
        var panel = item.querySelector('[data-dm-faq-panel]');
        if (!trigger || !panel) return;

        trigger.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          items.forEach(function (other) {
            var otherTrigger = other.querySelector('[data-dm-faq-trigger]');
            var otherPanel = other.querySelector('[data-dm-faq-panel]');
            other.classList.remove('is-open');
            if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.setAttribute('hidden', '');
          });

          if (willOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.removeAttribute('hidden');
          }
        });
      });
    });
  }

  function initReveal(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll('.dm-direct-stat, .dm-direct-story, .dm-sol-reveal');

    if (!nodes.length) {
      initIndustries(scope);
      initStatCounters(scope);
      initTestimonials(scope);
      initFaqAccordion(scope);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(nodes, function (n) {
        n.classList.add('is-visible');
      });
      initIndustries(scope);
      initStatCounters(scope);
      initTestimonials(scope);
      initFaqAccordion(scope);
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.2 }
      );
    }

    Array.prototype.forEach.call(nodes, function (n) {
      if (n.hasAttribute('data-dm-reveal-bound')) return;
      n.setAttribute('data-dm-reveal-bound', '');
      n.classList.add('dm-direct-reveal');
      revealObserver.observe(n);
    });

    initIndustries(scope);
    initStatCounters(scope);
    initTestimonials(scope);
    initFaqAccordion(scope);
  }

  function initFooterReveal() {
    var footer = document.querySelector('[data-dm-direct-footer-reveal]');
    if (!footer) return;
    var brand = footer.querySelector('[data-dm-footer-brand]');
    if (!brand) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      brand.style.setProperty('--dm-footer-progress', '1');
      return;
    }

    document.documentElement.classList.add('dm-direct-motion-ready');

    var ticking = false;

    function clamp(value) {
      return value < 0 ? 0 : value > 1 ? 1 : value;
    }

    // Pattern-style scroll scrub:
    // keep animation-play-state: paused and drive progress via --dm-footer-progress
    // (negative animation-delay), so scrolling up reverses the reveal.
    function update() {
      ticking = false;
      var rect = footer.getBoundingClientRect();
      var viewport = window.innerHeight || 1;
      var height = Math.max(rect.height, 1);
      // 0 when sticky block enters viewport bottom; 1 when fully settled (Framer: start end → end end).
      var progress = clamp((viewport - rect.top) / height);
      brand.style.setProperty('--dm-footer-progress', progress.toFixed(4));
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  function normalizeHandle(value) {
    return (value || '').toLowerCase().replace(/\/+$/, '');
  }

  function getRouteHandle() {
    var hashMatch = (location.hash || '').match(/^#\/?dm\/([a-z0-9-]+)/i);
    if (hashMatch) return normalizeHandle(hashMatch[1]);

    var pathMatch = (location.pathname || '').match(/^\/pages\/([a-z0-9-]+)\/?$/i);
    if (pathMatch) {
      var handle = normalizeHandle(pathMatch[1]);
      if (TITLES[handle]) return handle;
    }
    return '';
  }

  function setTitle(handle) {
    if (!TITLES[handle]) return;
    var shop = document.title.split('–').pop() || 'District Mailing';
    document.title = TITLES[handle] + ' –' + shop;
  }

  function syncNavForRoute(isHome) {
    // Two-tier sticky header — no overlay mode to sync.
  }

  var homeScrollY = null;

  function setHeroPlayback(homeVisible) {
    var video = document.querySelector('[data-dm-direct-view] .dm-direct-hero__media video');
    if (!video) return;
    try {
      if (!homeVisible) {
        if (!video.paused) video.pause();
        return;
      }
      if (!video.paused) return;
      var playing = video.play();
      if (playing && playing.catch) playing.catch(function () {});
    } catch (err) {
      /* autoplay restrictions — nothing to do */
    }
  }

  function blankRouteMarkup(handle) {
    return (
      '<section class="dm-direct-blank">' +
      '<div class="dm-direct__wrap dm-direct-blank__inner">' +
      '<p class="dm-direct-eyebrow" style="color:var(--dm-blue);">District Mailing Direct</p>' +
      '<h1 class="dm-direct-blank__title">' +
      (TITLES[handle] || 'Coming Soon') +
      '</h1>' +
      '<p class="dm-direct-blank__note">This page is ready for content. We\u2019ll build it next.</p>' +
      '<div class="dm-direct-blank__actions">' +
      '<a class="dm-direct-btn dm-direct-btn--primary" href="/pages/dm-direct-contact">Partner With Us</a>' +
      '<a class="dm-direct-btn dm-direct-btn--ghost" href="/pages/dm-for-brands">&larr; Back to Direct</a>' +
      '</div></div></section>'
    );
  }

  function applyDirectRoute() {
    closeNavMenus();
    var app = document.querySelector('[data-dm-direct-app]');
    var homeView = document.querySelector('[data-dm-direct-view]');
    var routeView = document.querySelector('[data-dm-direct-route-view]');
    if (!app || !homeView || !routeView) return false;

    var handle = getRouteHandle();
    var isHome = !handle || HOME_HANDLES[handle];
    var isInner = app.classList.contains('dm-direct--inner');

    if (isInner) {
      var pageHandle = normalizeHandle(app.getAttribute('data-dm-direct-page') || '');
      if (isHome || handle === pageHandle) {
        routeView.setAttribute('hidden', '');
        routeView.innerHTML = '';
        homeView.removeAttribute('hidden');
        document.documentElement.classList.remove('dm-direct-route-pending');
        initReveal(homeView);
        return true;
      }
    }

    if (isHome) {
      routeView.setAttribute('hidden', '');
      routeView.innerHTML = '';
      homeView.removeAttribute('hidden');
      document.documentElement.classList.remove('dm-direct-route-pending');
      document.title = 'District Mailing Direct –' + (document.title.split('–').pop() || ' District Mailing');
      syncNavForRoute(true);
      setHeroPlayback(true);
      initReveal(homeView);
      if (location.hash === '#customers') {
        var customers = document.getElementById('customers');
        if (customers) customers.scrollIntoView();
      } else if (homeScrollY !== null) {
        window.scrollTo(0, homeScrollY);
        homeScrollY = null;
      }
      return true;
    }

    var tpl = document.querySelector('template[data-dm-direct-tpl="' + handle + '"]');
    if (!homeView.hasAttribute('hidden')) homeScrollY = window.pageYOffset || 0;
    routeView.innerHTML = tpl ? tpl.innerHTML : blankRouteMarkup(handle);
    homeView.setAttribute('hidden', '');
    routeView.removeAttribute('hidden');
    document.documentElement.classList.remove('dm-direct-route-pending');
    setTitle(handle);
    syncNavForRoute(false);
    setHeroPlayback(false);
    window.scrollTo(0, 0);
    initReveal(routeView);
    return true;
  }

  function navigateTo(handle) {
    closeNavMenus();

    var isHome = !handle || HOME_HANDLES[handle];
    var target = isHome ? DIRECT_HOME_PATH : '/pages/' + handle;
    var app = document.querySelector('[data-dm-direct-app]');

    // Standalone Direct inner pages have no homepage markup — hard-load Direct home.
    if (isHome && app && app.classList.contains('dm-direct--inner')) {
      location.href = DIRECT_HOME_PATH;
      return;
    }

    if (window.history && window.history.pushState) {
      if (location.pathname !== target) {
        window.history.pushState({ dmDirect: handle || 'home' }, '', target);
      }
      applyDirectRoute();
      return;
    }
    location.href = target;
  }

  function interceptDirectLinks() {
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var link = event.target.closest('a[href]');
      if (!link) return;
      if (link.target === '_blank' || link.hasAttribute('download')) return;
      // Let "Back to Shop" leave Direct for the main storefront.
      if (link.hasAttribute('data-dm-exit-direct')) {
        closeNavMenus();
        return;
      }

      var href = (link.getAttribute('href') || '').split('?')[0];
      var handle = '';

      if (
        href === DIRECT_HOME_PATH ||
        href === '/pages/for-brands' ||
        href === '/pages/district-mailing-direct' ||
        href === '/pages/dm-for-brands'
      ) {
        handle = 'home';
      } else {
        var pageMatch = href.match(/^\/pages\/([a-z0-9-]+)\/?$/i);
        var hashMatch = href.match(/^#\/?dm\/([a-z0-9-]+)/i);
        if (pageMatch) handle = normalizeHandle(pageMatch[1]);
        if (hashMatch) handle = normalizeHandle(hashMatch[1]);
        if (!handle || (!TITLES[handle] && !HOME_HANDLES[handle])) return;
      }

      // Only take over navigation where the Direct shell can render the route in place.
      if (!document.querySelector('[data-dm-direct-app]') || !document.querySelector('[data-dm-direct-route-view]')) {
        closeNavMenus();
        return;
      }

      event.preventDefault();
      navigateTo(handle === 'home' ? '' : handle);
    });
  }

  function initInfiniteMarquees() {
    var tracks = Array.prototype.slice.call(
      document.querySelectorAll('.dm-direct-marquee__track, .dm-direct-partners__track')
    );
    if (!tracks.length) return;

    tracks.forEach(function (track) {
      if (track.dataset.dmMarqueeInit === '1') return;
      track.dataset.dmMarqueeInit = '1';

      // Drive scroll in JS so Shopify CSS minification cannot break keyframes.
      track.style.animation = 'none';
      track.style.willChange = 'transform';

      var durationMs = track.classList.contains('dm-direct-partners__track') ? 32000 : 28000;
      var offset = 0;
      var last = 0;
      var running = false;

      function trackGap() {
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap);
        return isFinite(gap) ? gap : 0;
      }

      function ensureCopies() {
        var firstSet = track.children[0];
        if (!firstSet) return null;

        var parent = track.parentElement;
        var minWidth = parent ? parent.getBoundingClientRect().width * 2 + 48 : 0;
        var guard = 0;

        while (track.children.length < 2 && guard < 4) {
          var clone = firstSet.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          track.appendChild(clone);
          guard += 1;
        }

        guard = 0;
        while (track.scrollWidth < minWidth && guard < 8) {
          var extra = firstSet.cloneNode(true);
          extra.setAttribute('aria-hidden', 'true');
          track.appendChild(extra);
          guard += 1;
        }

        return firstSet;
      }

      function loopDistance() {
        var firstSet = track.children[0];
        if (!firstSet) return 0;
        // One full loop = one set + the gap before the next identical set (no blank seam).
        return firstSet.getBoundingClientRect().width + trackGap();
      }

      function frame(now) {
        if (!last) last = now;
        var dt = Math.min(48, now - last);
        last = now;

        var size = loopDistance();
        if (size > 1) {
          offset -= (size / durationMs) * dt;
          while (offset <= -size) offset += size;
          track.style.transform = 'translate3d(' + offset.toFixed(2) + 'px,0,0)';
        }

        window.requestAnimationFrame(frame);
      }

      function start() {
        if (running) return;
        ensureCopies();
        if (!track.children[0]) return;
        running = true;
        last = 0;
        window.requestAnimationFrame(frame);
      }

      var images = Array.prototype.slice.call(track.querySelectorAll('img'));
      var pending = images.filter(function (img) {
        return !img.complete;
      }).length;

      if (!pending) {
        start();
        return;
      }

      var onReady = function () {
        pending -= 1;
        if (pending <= 0) start();
      };

      images.forEach(function (img) {
        if (img.complete) return;
        img.addEventListener('load', onReady, { once: true });
        img.addEventListener('error', onReady, { once: true });
      });

      // Fallback if some images hang
      window.setTimeout(start, 1500);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-dm-direct-route-view]') && 'scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    initNav();
    interceptDirectLinks();
    if (!applyDirectRoute()) initReveal();
    document.documentElement.classList.remove('dm-direct-route-pending');
    initFooterReveal();
    initInfiniteMarquees();
    window.addEventListener('hashchange', applyDirectRoute);
    window.addEventListener('popstate', applyDirectRoute);
  });
})();
